import { BrowserModule } from '@angular/platform-browser';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { BnNgIdleService } from 'bn-ng-idle';
import { AppBootstrapperService } from './shared/services/app-bootstrapper/app-bootstrapper.service';
import { HttpRequestService } from './shared/services/http-request/http-request.service';
import { UserSessionService } from './shared/services/user-session/user-session.service';
import { HeaderActionsService } from './shared/services/header-actions/header-actions.service';
import { ModalControllerService } from './shared/services/modal-controller/modal-controller.service';
import { AlertControllerService } from './shared/services/alert-controller/alert-controller.service';
import { MenuItemsService } from './shared/services/menu-items/menu-items.service';
import { SharedItemsService } from './shared/services/shared-items/shared-items.service';
import { AppNetworkService } from './shared/services/app-network-service/app-network.service';
import { LocalStorageService } from './shared/services/local-storage/local-storage.service';
import { CustomClipboardService } from './shared/services/custom-clipboard/custom-clipboard.service';
import { SignalRManagerService } from './shared/services/signalR-manager/signal-r-manager.service';
import { UserAgentService } from './shared/services/user-agent/user-agent.service';
import { AuthService } from './login/auth/auth.service';
import {
 AppConfigService,
 configFactory
} from './shared/services/app-config/app-config.service';
import { AppHttpInterceptor } from './shared/interceptors/http.interceptor';
import { SabisChatbotComponent } from './shared/components/sabis-chatbot/sabis-chatbot.component';
import { ChatbotConfirmationService } from './shared/services/sabis-chatbot/chatbot-confirmation.service';
import { ChatbotApiService } from './shared/services/sabis-chatbot/chatbot-api.service';
import { InMemoryMessageService } from './shared/services/sabis-chatbot/message.memory.service';
import { ChatbotHttpRequestService } from './shared/services/http-request/chatbot-http-request.service';
import { ChatbotHistoryService } from 'sabis-chatbot';
@NgModule({
 imports: [
   CommonModule,
   BrowserModule,
   BrowserAnimationsModule,
   HttpClientModule,
   RouterModule,
   SharedModule,
   AppRoutingModule,
   SabisChatbotComponent
 ],
 providers: [
   BnNgIdleService,
   HeaderActionsService,
   HttpRequestService,
   UserSessionService,
   ModalControllerService,
   AlertControllerService,
   MenuItemsService,
   SharedItemsService,
   AppNetworkService,
   LocalStorageService,
   CustomClipboardService,
   SignalRManagerService,
   UserAgentService,
   AuthService,
   AppBootstrapperService,
   ChatbotHttpRequestService,
   ChatbotHistoryService,
   {
     provide: HTTP_INTERCEPTORS,
     useClass: AppHttpInterceptor,
     multi: true
   },
   provideAppInitializer(() =>
     configFactory(inject(AppConfigService))()
   ),
   {
     provide: 'ChatbotDialogService',
     useClass: ChatbotConfirmationService
   },
   {
     provide: 'ChatbotApiService',
     useClass: ChatbotApiService
   },
   {
     provide: 'MessageService',
     useClass: InMemoryMessageService
   },
   {
     provide: 'ChatbotHistoryApiService',
     useClass: ChatbotApiService
   }
 ]
})
export class AppModule {}